/**
 * Silent Session remint when `/session` reports `expiresSoon` (ADR-0018).
 */

export type SessionRemintOutcome = 'skipped' | 'reminted' | 'failed';

export async function remintSessionIfExpiresSoon(options: {
  expiresSoon: boolean | undefined;
  getIdToken: (forceRefresh?: boolean) => Promise<string>;
  completeLogin: (idToken: string) => Promise<Response>;
}): Promise<SessionRemintOutcome> {
  if (!options.expiresSoon) {
    return 'skipped';
  }

  const idToken = await options.getIdToken(true);
  const response = await options.completeLogin(idToken);
  return response.ok ? 'reminted' : 'failed';
}
